type LogLevel = 'error' | 'warn' | 'info' | 'log' | 'debug'
type LogMethod = (...args: unknown[]) => void

type Logger = {
	error: LogMethod
	warn: LogMethod
	info: LogMethod
	log: LogMethod
	debug: LogMethod
}

const allowedLevelsInProduction: LogLevel[] = ['error']

const createLogger = (context?: string): Logger => {
	const prefix = context ? `[${context}]` : undefined

	const shouldLog = (level: LogLevel) => {
		if (import.meta.env.PROD) return allowedLevelsInProduction.includes(level)
		return true
	}

	const withPrefix = (args: unknown[]) => prefix ? [prefix, ...args] : args

	// oxlint-disable no-console
	const error: LogMethod = (...args) => { if (shouldLog('error')) console.error(...withPrefix(args)) }
	const warn: LogMethod = (...args) => { if (shouldLog('warn')) console.warn(...withPrefix(args)) }
	const info: LogMethod = (...args) => { if (shouldLog('info')) console.info(...withPrefix(args)) }
	const log: LogMethod = (...args) => { if (shouldLog('log')) console.log(...withPrefix(args)) }
	const debug: LogMethod = (...args) => { if (shouldLog('debug')) console.debug(...withPrefix(args)) }
	// oxlint-enable no-console

	return { error, warn, info, log, debug }
}

const logger = createLogger()

export { logger, createLogger }
export type { Logger }
